// extracted by mini-css-extract-plugin
export var cardLayout = "_5n-1";
export var paginationContainer = "_5n-0";